module.exports = __webpack_public_path__ + "static/media/1.dc71cf42.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_138/images/悬浮窗/1.png
// module id = 1303
// module chunks = 0